export default __webpack_public_path__ + "static/media/5.bb2852bb.jpg";